import { AxiosResponse } from "axios";
import fileDownload from "js-file-download";
import { AppDispatch } from "store";
import { NoteForm } from "store/reducers/activity-log/add-note/types";
import { AddLodgingOptionData, AddLodgingOptionParams, ADD_LODGING_OPTION_DATA_FAILURE, ADD_LODGING_OPTION_DATA_REQUEST, ADD_LODGING_OPTION_DATA_SUCCESS } from "store/reducers/lodgingOption/add/types";
import { DeleteLodgingOptionData, DELETE_LODGING_OPTION_FAILURE, DELETE_LODGING_OPTION_REQUEST, DELETE_LODGING_OPTION_SUCCESS } from "store/reducers/lodgingOption/delete/types";
import { CloseLodgingOptionData, CLOSE_LODGING_OPTION_FAILURE, CLOSE_LODGING_OPTION_REQUEST, CLOSE_LODGING_OPTION_SUCCESS } from "store/reducers/lodgingOption/close/types";
import { ReactivateLodgingOptionData, REACTIVATE_LODGING_OPTION_FAILURE, REACTIVATE_LODGING_OPTION_REQUEST, REACTIVATE_LODGING_OPTION_SUCCESS } from "store/reducers/lodgingOption/reactivate/types";
import { EditLodgingOptionData, EditLodgingOptionParams, EDIT_LODGING_OPTION_DATA_FAILURE, EDIT_LODGING_OPTION_DATA_REQUEST, EDIT_LODGING_OPTION_DATA_SUCCESS } from "store/reducers/lodgingOption/edit/types";
import { LODGING_OPTION_EXPORT_EXCEL_FAILURE, LODGING_OPTION_EXPORT_EXCEL_REQUEST, LODGING_OPTION_EXPORT_EXCEL_SUCCESS, LodgingOptionExportExcelParams } from "store/reducers/lodgingOption/exportExcel/types";
import { GET_LODGING_OPTION_ACTIVITY_LOGS_FAILURE, GET_LODGING_OPTION_ACTIVITY_LOGS_REQUEST, GET_LODGING_OPTION_ACTIVITY_LOGS_SUCCESS } from "store/reducers/lodgingOption/get-activity-logs/types";
import { GetLodgingsData, GetLodgingsParams, GET_LODGINGS_DATA_FAILURE, GET_LODGINGS_DATA_REQUEST, GET_LODGINGS_DATA_SUCCESS } from "store/reducers/lodgingOption/get/types";
import { LodgingFormData, READ_LODGING_FORM_DATA_FAILURE, READ_LODGING_FORM_DATA_REQUEST, READ_LODGING_FORM_DATA_SUCCESS } from "store/reducers/lodgingOption/getFormData/types";
import { LOCATION_MATCHES_FOR_MASS_BOOKING_FAILURE, LOCATION_MATCHES_FOR_MASS_BOOKING_REQUEST, LOCATION_MATCHES_FOR_MASS_BOOKING_SUCCESS } from "store/reducers/lodgingOption/location-matches-for-mass-booking/types";
import { LocationMatchesData, LOCATION_MATCHES_FAILURE, LOCATION_MATCHES_REQUEST, LOCATION_MATCHES_SUCCESS } from "store/reducers/lodgingOption/locationMatches/types";
import { LodgingOptionMassAddData, LodgingOptionMassAddParams, LODGING_OPTION_MASS_ADD_DATA_FAILURE, LODGING_OPTION_MASS_ADD_DATA_REQUEST, LODGING_OPTION_MASS_ADD_DATA_SUCCESS } from "store/reducers/lodgingOption/massAdd/types";
import { SearchReservationData, SearchReservationParams, SEARCH_RESERVATION_FAILURE, SEARCH_RESERVATION_REQUEST, SEARCH_RESERVATION_SUCCESS } from "store/reducers/lodgingOption/searchReservation/types";
import { ViewLodgingOptionData, VIEW_LODGING_OPTION_DATA_FAILURE, VIEW_LODGING_OPTION_DATA_REQUEST, VIEW_LODGING_OPTION_DATA_SUCCESS } from "store/reducers/lodgingOption/view/types";
import { BaseTableRequest, DropdownItem, Filters } from "store/types";
import { apiRequest } from "utils/api";
import { GET_LOCATION_MATCHES_BY_REQUEST_DATA_FAILURE, GET_LOCATION_MATCHES_BY_REQUEST_DATA_REQUEST, GET_LOCATION_MATCHES_BY_REQUEST_DATA_SUCCESS, GetLocationMatchesByRequestParams, GetLocationMatchesByRequestRowResponse } from 'store/reducers/lodgingOption/get-location-matches-by-request/types';
import { GET_ADDRESSES_FOR_FILTER_FAILURE, GET_ADDRESSES_FOR_FILTER_REQUEST, GET_ADDRESSES_FOR_FILTER_SUCCESS, GetAddressesForFilterData, GetAddressesForFilterParams } from "store/reducers/lodgingOption/get-addresses-for-filter/types";
import { GET_TYPES_FOR_FILTER_FAILURE, GET_TYPES_FOR_FILTER_REQUEST, GET_TYPES_FOR_FILTER_SUCCESS } from "store/reducers/lodgingOption/get-types-for-filter/types";
import { GetLodgingsNamesForFilterParams, GetLodgingsNamesForFilterData, GET_LODGINGS_NAMES_FOR_FILTER_REQUEST, GET_LODGINGS_NAMES_FOR_FILTER_SUCCESS, GET_LODGINGS_NAMES_FOR_FILTER_FAILURE } from "store/reducers/lodgingOption/get-lodging-names-for-filter/types";
import { SET_LODGING_TABLE_FILTERS } from "store/reducers/lodgingOption/lodging-table-filters/types";
import { MERGE_LODGING_OPTION_FAILURE, MERGE_LODGING_OPTION_REQUEST, MERGE_LODGING_OPTION_SUCCESS, MergeLodgingOptionData, MergeLodgingOptionParams } from "store/reducers/lodgingOption/merge-lodging-options/types";
import { LODGING_OPTION_REPORT_EXCEL_FAILURE, LODGING_OPTION_REPORT_EXCEL_REQUEST, LODGING_OPTION_REPORT_EXCEL_SUCCESS, LodgingOptionReportExcelParams } from "store/reducers/lodgingOption/getReportExcel/types";
import { GET_LODGINGS_COUNT_DATA_FAILURE, GET_LODGINGS_COUNT_DATA_REQUEST, GET_LODGINGS_COUNT_DATA_SUCCESS } from 'store/reducers/lodgingOption/get-count/types';

export function getLodgingFormData(id?: string): any {
  return async (dispatch: AppDispatch): Promise<LodgingFormData> => {
    dispatch({ type: READ_LODGING_FORM_DATA_REQUEST });

    const queryString: string = id ? `?id=${id}` : '';

    try {
      const response = await apiRequest(
        "get",
        `lodging-option/get-form-data${queryString}`
      );

      dispatch({
        type: READ_LODGING_FORM_DATA_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: READ_LODGING_FORM_DATA_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function addLodgingOption(params: AddLodgingOptionParams): any {
  return async (dispatch: AppDispatch): Promise<AddLodgingOptionData> => {
    dispatch({ type: ADD_LODGING_OPTION_DATA_REQUEST });

    try {
      const response = await apiRequest(
        "post",
        `lodging-option/add`,
        {
          data: params
        }
      );
      dispatch({
        type: ADD_LODGING_OPTION_DATA_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: ADD_LODGING_OPTION_DATA_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function getLodgings(params: GetLodgingsParams): any {
  return async (dispatch: AppDispatch): Promise<GetLodgingsData> => {
    dispatch({ type: GET_LODGINGS_DATA_REQUEST });

    try {
      const response = await apiRequest(
        "post",
        `lodging-option/get`,
        {
          data: params
        }
      );
      dispatch({
        type: GET_LODGINGS_DATA_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: GET_LODGINGS_DATA_FAILURE,
        error
      });

      throw response;
    }
  };
};


export function editLodgingOption(params: EditLodgingOptionParams): any {
  return async (dispatch: AppDispatch): Promise<EditLodgingOptionData> => {
    dispatch({ type: EDIT_LODGING_OPTION_DATA_REQUEST });

    try {
      const response = await apiRequest(
        "put",
        `lodging-option/edit`,
        {
          data: params
        }
      );

      dispatch({
        type: EDIT_LODGING_OPTION_DATA_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: EDIT_LODGING_OPTION_DATA_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function viewLodgingOption(id: string): any {
  return async (dispatch: AppDispatch): Promise<ViewLodgingOptionData> => {
    dispatch({ type: VIEW_LODGING_OPTION_DATA_REQUEST });

    try {
      const response = await apiRequest(
        "get",
        `lodging-option/view/${id}`,
      );
      dispatch({
        type: VIEW_LODGING_OPTION_DATA_SUCCESS,
        contents: response?.data
      });

      return response?.data;
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: VIEW_LODGING_OPTION_DATA_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function deleteLodgingOption(id: string): any {
  return async (dispatch: AppDispatch): Promise<DeleteLodgingOptionData> => {
    dispatch({ type: DELETE_LODGING_OPTION_REQUEST });

    try {
      const response = await apiRequest(
        "delete",
        `lodging-option/delete/${id}`,
      );

      dispatch({
        type: DELETE_LODGING_OPTION_SUCCESS,
        contents: response?.data
      });

      return response?.data;
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: DELETE_LODGING_OPTION_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function closeLodgingOption(id: string): any {
  return async (dispatch: AppDispatch): Promise<CloseLodgingOptionData> => {
    dispatch({ type: CLOSE_LODGING_OPTION_REQUEST });

    try {
      const response = await apiRequest('put', `lodging-option/close/${id}`);

      dispatch({
        type: CLOSE_LODGING_OPTION_SUCCESS,
        contents: response?.data
      });

      return response?.data;
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: CLOSE_LODGING_OPTION_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function reactivateLodgingOption(id: string): any {
  return async (dispatch: AppDispatch): Promise<ReactivateLodgingOptionData> => {
    dispatch({ type: REACTIVATE_LODGING_OPTION_REQUEST });

    try {
      const response = await apiRequest('put', `lodging-option/reactivate/${id}`);

      dispatch({
        type: REACTIVATE_LODGING_OPTION_SUCCESS,
        contents: response?.data
      });

      return response?.data;
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: REACTIVATE_LODGING_OPTION_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function getLodgingsCount(data: Filters): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: GET_LODGINGS_COUNT_DATA_REQUEST });
    try {
      const response = await apiRequest('post', `lodging-option/get-count`, { data });
      dispatch({ type: GET_LODGINGS_COUNT_DATA_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_LODGINGS_COUNT_DATA_FAILURE, error });
      throw response;
    }
  };
}

export function searchReservation(params: SearchReservationParams): any {
  return async (dispatch: AppDispatch): Promise<SearchReservationData> => {
    dispatch({ type: SEARCH_RESERVATION_REQUEST });

    try {
      const response = await apiRequest(
        "post",
        `lodging-option/search-for-add-reservation`,
        {
          data: params
        }
      );
      dispatch({
        type: SEARCH_RESERVATION_SUCCESS,
        contents: response?.data
      });

      return response?.data;
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: SEARCH_RESERVATION_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function locationMatches(id: string): any {
  return async (dispatch: AppDispatch): Promise<LocationMatchesData> => {
    dispatch({ type: LOCATION_MATCHES_REQUEST });

    try {
      const response = await apiRequest(
        "get",
        `lodging-option/location-matches/${id}`,
      );
      dispatch({
        type: LOCATION_MATCHES_SUCCESS,
        contents: response?.data
      });

      return response?.data;
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: LOCATION_MATCHES_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function lodgingOptionMassAdd(params: LodgingOptionMassAddParams): any {
  return async (dispatch: AppDispatch): Promise<LodgingOptionMassAddData> => {
    dispatch({ type: LODGING_OPTION_MASS_ADD_DATA_REQUEST });

    try {
      const response = await apiRequest(
        'post',
        'lodging-option/mass-add',
        {
          data: params.data
        },
        true,
        params.onUploadProgress,
        params.cancelToken
      );

      dispatch({
        type: LODGING_OPTION_MASS_ADD_DATA_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: LODGING_OPTION_MASS_ADD_DATA_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function exportExcel(params: LodgingOptionExportExcelParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: LODGING_OPTION_EXPORT_EXCEL_REQUEST });

    try {
      const response: AxiosResponse<any> = await apiRequest(
        "post",
        `lodging-option/export-excel`,
        {
          data: params,
          responseType: 'blob',
        }
      ) as AxiosResponse<any>;

      const contentDisposition: string | undefined = response.headers['content-disposition'];

      if (contentDisposition) {
        const matchHeader: RegExpMatchArray | null = contentDisposition.match(/filename=(.*)/);
        const fileName: string = matchHeader && matchHeader[1] ? matchHeader[1] : 'Lodgings.xlsx';

        fileDownload(response.data, fileName, response.headers['content-type']);
      }

      dispatch({
        type: LODGING_OPTION_EXPORT_EXCEL_SUCCESS,
      });
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: LODGING_OPTION_EXPORT_EXCEL_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function getReportExcel(params: LodgingOptionReportExcelParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: LODGING_OPTION_REPORT_EXCEL_REQUEST });

    try {
      const response: AxiosResponse<any> = await apiRequest(
        "post",
        `lodging-option/get-report-excel`,
        {
          data: params,
          responseType: 'blob',
        }
      ) as AxiosResponse<any>;

      const contentDisposition: string | undefined = response.headers['content-disposition'];

      if (contentDisposition) {
        const matchHeader: RegExpMatchArray | null = contentDisposition.match(/filename=(.*)/);
        const fileName: string = matchHeader && matchHeader[1] ? matchHeader[1] : 'Reservations.xlsx';

        fileDownload(response.data, fileName, response.headers['content-type']);
      }

      dispatch({
        type: LODGING_OPTION_REPORT_EXCEL_SUCCESS,
      });
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: LODGING_OPTION_REPORT_EXCEL_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function getActivityLogs(id: string, data: BaseTableRequest): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: GET_LODGING_OPTION_ACTIVITY_LOGS_REQUEST });

    try {
      const response = await apiRequest('post', `lodging-option/${id}/get-activity-logs`, { data });
      dispatch({ type: GET_LODGING_OPTION_ACTIVITY_LOGS_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_LODGING_OPTION_ACTIVITY_LOGS_FAILURE, error });
      throw response;
    }
  };
};

export async function addNote(id: string, data: NoteForm) {
  try {
    await apiRequest('post', `lodging-option/${id}/notes/add`, { data });
  } catch (response: any) {
    throw response;
  }
}

export async function editNote(id: string, noteId: string, data: NoteForm) {
  try {
    await apiRequest('put', `lodging-option/${id}/notes/${noteId}/edit`, { data });
  } catch (response: any) {
    throw response;
  }
}

export async function deleteNote(id: string, noteId: string) {
  try {
    await apiRequest('delete', `lodging-option/${id}/notes/${noteId}`);
  } catch (response: any) {
    throw response;
  }
}

export function getLocationMatchesForMassBooking(requestsIds: string[]): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: LOCATION_MATCHES_FOR_MASS_BOOKING_REQUEST });
    try {
      const response = await apiRequest('post', 'lodging-option/location-matches-for-mass-booking', { data: { requestsIds } });
      dispatch({ type: LOCATION_MATCHES_FOR_MASS_BOOKING_SUCCESS, contents: response?.data });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: LOCATION_MATCHES_FOR_MASS_BOOKING_FAILURE, error });
      throw response;
    }
  };
};

export function getLocationMatchesByRequest(data: GetLocationMatchesByRequestParams): any {
  return async (dispatch: AppDispatch): Promise<GetLocationMatchesByRequestRowResponse> => {
    dispatch({ type: GET_LOCATION_MATCHES_BY_REQUEST_DATA_REQUEST });

    try {
      const response = await apiRequest(
        "post",
        `lodging-option/get-location-matches-by-request`,
        { data: data }
      );
      dispatch({
        type: GET_LOCATION_MATCHES_BY_REQUEST_DATA_SUCCESS,
        contents: response?.data
      });

      return response?.data;
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: GET_LOCATION_MATCHES_BY_REQUEST_DATA_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function getAddressesForFilter(data: GetAddressesForFilterParams): any {
  return async (dispatch: AppDispatch): Promise<GetAddressesForFilterData> => {
    dispatch({ type: GET_ADDRESSES_FOR_FILTER_REQUEST });
    try {
      const response = await apiRequest('post', 'lodging-option/get-addresses-for-filter', { data });
      dispatch({ type: GET_ADDRESSES_FOR_FILTER_SUCCESS, contents: response?.data || {} });
      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_ADDRESSES_FOR_FILTER_FAILURE, error });
      throw response;
    }
  };
};

export function getTypesForFilter(): any {
  return async (dispatch: AppDispatch): Promise<DropdownItem[]> => {
    dispatch({ type: GET_TYPES_FOR_FILTER_REQUEST });
    try {
      const response = await apiRequest('post', 'lodging-option/lodging-types');
      dispatch({ type: GET_TYPES_FOR_FILTER_SUCCESS, contents: response?.data || {} });
      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_TYPES_FOR_FILTER_FAILURE, error });
      throw response;
    }
  };
};

export function setLodgingTableFilters(filters: Filters): any {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch({
        type: SET_LODGING_TABLE_FILTERS,
        contents: filters,
        exists: Object.keys(filters).some(key => filters[key]),
      });
    } catch { }
  };
}

export function getLodgingsNamesForFilter(data: GetLodgingsNamesForFilterParams): any {
  return async (dispatch: AppDispatch): Promise<GetLodgingsNamesForFilterData> => {
    dispatch({ type: GET_LODGINGS_NAMES_FOR_FILTER_REQUEST });
    try {
      const response = await apiRequest('post', 'lodging-option/get-lodgings-names-for-filter', { data });
      dispatch({ type: GET_LODGINGS_NAMES_FOR_FILTER_SUCCESS, contents: response?.data || {} });
      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_LODGINGS_NAMES_FOR_FILTER_FAILURE, error });
      throw response;
    }
  };
}

export function mergeLodgingOptions(data: MergeLodgingOptionParams): any {
  return async (dispatch: AppDispatch): Promise<MergeLodgingOptionData> => {
    dispatch({ type: MERGE_LODGING_OPTION_REQUEST });
    try {
      const response = await apiRequest('post', 'lodging-option/merge-lodging-options', { data });

      dispatch({
        type: MERGE_LODGING_OPTION_SUCCESS,
        contents: response?.data
      });

      return response?.data;
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: MERGE_LODGING_OPTION_FAILURE,
        error
      });
      throw response;
    }
  };
};